import { UpgradeStatus } from 'app/model/valueObjects/upgradeStatus';

export function upgradeProgressing(upgradeStatus: UpgradeStatus): boolean {
  return UpgradeStatus.RUNNING === upgradeStatus;
}

export function upgradeDone(upgradeStatus: UpgradeStatus): boolean {
  return [UpgradeStatus.COMPLETE, UpgradeStatus.LATEST].includes(upgradeStatus);
}
